import React from "react";
import PropTypes from "prop-types";
//Material imports
import { useTheme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(theme => ({
  responsiveImageStyles: {
    maxWidth: ({
      smallSrc,
      mediumSrc
    }) => smallSrc ? theme.breakpoints.values.sm : mediumSrc ? theme.breakpoints.values.md : "100%"
  }
}));
const ResponsiveImage = ({
  images,
  imageAlt,
  imageStyles,
  noImageSrc
}) => {
  const getImageUrl = size => {
    var _images$find;
    return images === null || images === void 0 ? void 0 : (_images$find = images.find(item => item.size === size)) === null || _images$find === void 0 ? void 0 : _images$find.url;
  };
  const theme = useTheme();
  const {
    smallSrc,
    mediumSrc,
    largeSource
  } = React.useMemo(() => {
    return {
      smallSrc: getImageUrl("small"),
      mediumSrc: getImageUrl("medium"),
      largeSource: getImageUrl("large")
    };
  }, [images, getImageUrl]);
  const classes = useStyles({
    smallSrc,
    mediumSrc
  });
  if (!smallSrc && !mediumSrc && !largeSource && noImageSrc) {
    return /*#__PURE__*/React.createElement("img", {
      src: noImageSrc,
      className: imageStyles
    });
  }
  return /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    media: theme.breakpoints.down("sm"),
    srcSet: smallSrc
  }), /*#__PURE__*/React.createElement("source", {
    media: theme.breakpoints.down("md"),
    srcSet: mediumSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: largeSource || mediumSrc || smallSrc,
    alt: imageAlt,
    className: `${imageStyles} ${classes.responsiveImageStyles}`
  }));
};
ResponsiveImage.propTypes = {
  images: PropTypes.array.isRequired,
  imageAlt: PropTypes.string.isRequired,
  imageStyles: PropTypes.string,
  noImageSrc: PropTypes.string
};
export default ResponsiveImage;